import { render, staticRenderFns } from "./ModalPaymentFileAttach.vue?vue&type=template&id=4651bd5f&lang=pug"
import script from "./ModalPaymentFileAttach.vue?vue&type=script&lang=js"
export * from "./ModalPaymentFileAttach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports